import React from 'react';
import Typography from '@mui/material/Typography';
import { CustomTypographyProps } from '../../types/ui';

const CustomTypography = ({ variant, children, sx, ...props } :CustomTypographyProps) => {
    return (
        <Typography variant={variant} sx={sx} {...props}>
            {children}
        </Typography>
    );
};

export default CustomTypography;
